'use strict';

bbw.directive.bbwSigninModal = ['$fancyModal', '$timeout', function($fancyModal, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var activation = attrs.bbwSigninModal;
            var closeable = !!scope.$eval(attrs.closeable);
            var showTimeout = attrs.timeout;
            var opened = false;
            function open(event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                opened = true;
                $fancyModal.open({
                    themeClass: 'modal-signin',
                    templateUrl: bbw.templateUrl('modal-signin.html'),
                    showCloseButton: !!closeable,
                    closeOnEscape: !!closeable,
                    closeOnOverlayClick: !!closeable,
                    scope: scope
                });
            }
            if (activation == 'click') {
                element.on('click', open);
            } else if (!showTimeout) {
                open();
            }
            if (showTimeout) {
                $timeout(function() {
                    if (!opened) {
                        open();
                    }
                }, 1000 * +showTimeout);
            }
        }
    };
}];
